import { MedicalType } from "@qendo/medical/types";
import { OptionType } from "@qendo/types";
import { Stack, useLocalSearchParams } from "expo-router";
import { useMemo } from "react";
import { View } from "react-native";
import { DeleteMedicalButton } from "~/components/form/health-profile/DeleteMedicalButton";
import { HeaderButton } from "~/components/HeaderButton";
import { DataList } from "~/components/layout/DataList";
import { DataListItem } from "~/components/layout/DataListItem";
import { BasicGallery } from "~/components/layout/gallery/BasicGallery";
import { Page } from "~/components/layout/Page";
import { Title } from "~/components/layout/text";
import { Authorize } from "~/components/permission/Authorize";
import { Can } from "~/components/permission/Can";
import { Dismiss } from "~/components/permission/Dismiss";
import { Flex, Gap, Items, Padding } from "~/constants/layout";
import { useMedical } from "~/providers/MedicalProvider";
import { useOptions } from "~/providers/OptionsProvider";
import { filled } from "~/util";

const type = MedicalType.surgery;

export default function SurgeryDetails() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { findOption } = useOptions();
    const surgery = useMemo(() => findMedical(type, id), [id, findMedical]);

    if (!surgery) {
        return <Dismiss />;
    }

    const option = findOption(OptionType.surgeries, surgery.option_id);

    return (
        <Authorize ability="view" section="surgeries">
            <Stack.Screen
                options={{
                    title: "Procedure details",
                    headerRight: () => (
                        <Can ability="update" section="surgeries">
                            <HeaderButton
                                title="Edit"
                                href={{ pathname: "/health-profile/surgeries/[id]/edit", params: { id } }}
                            />
                        </Can>
                    ),
                }}
            />
            <Page spacer>
                <View style={[Padding.top_md, Gap.lg, Flex.flex]}>
                    <View style={[Items.start, Gap.xs]}>
                        {filled(option) && <Title size="xl">{option.title}</Title>}
                    </View>
                    <DataList>
                        <DataListItem title="Description" data={surgery.description} />
                    </DataList>
                    <BasicGallery images={surgery.photograph_ids} />
                </View>
                <DeleteMedicalButton type={type} id={id} />
            </Page>
        </Authorize>
    );
}
